import { useMutation } from '@tanstack/react-query';

import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { postDuplicateApplication } from '../../requests/postDuplicateApplication';

export const useDuplicateApplication = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: duplicateApplication, ...rest } = useMutation({
    mutationFn: (uuid: string) =>
      postDuplicateApplication(constructPost, uuid, definitionName),
    onSuccess: () => handleSuccess('Document duplicated.'),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Failed to duplicate document.')),
  });

  return { duplicateApplication, ...rest };
};
